var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable  @typescript-eslint/no-use-before-define */
import Path2d from '@byted/light-render/lib/geometry/Path2D';
import * as mat3 from '@byted/light-render/js/mat3';
import { Path, Image } from '../element';
var registeredSymbols = {};
export function getSymbolWidth(size) {
    return Array.isArray(size) ? size[0] : size;
}
export function getSymbolHeight(size) {
    return Array.isArray(size) ? size[1] : size;
}
export function getSymbolShapeFromCenter(cx, cy, size, borderRadius) {
    if (borderRadius === void 0) { borderRadius = 0; }
    var width = getSymbolWidth(size);
    var height = getSymbolHeight(size);
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height,
        borderRadius: borderRadius,
    };
}
export function registerSymbol(name, component, attrCreator) {
    registeredSymbols[name] = [component, attrCreator];
}
function getSymbolConstructor(symbol, type) {
    if (type === 'registered') {
        return registeredSymbols[symbol][0];
    }
    if (type === 'image' || type === 'url') {
        return Image;
    }
    if (type === 'path') {
        return Path;
    }
}
function getImageAttr(symbol, x, y, width, height) {
    return {
        src: symbol,
        x: x,
        y: y,
        width: width,
        height: height,
    };
}
function getPathAttr(path, x, y, width, height) {
    /// path://
    var pathData = new Path2d(path.slice(7));
    var bbox = pathData.getPathBBox();
    if (bbox.width === 0 || bbox.height === 0) {
        return {
            pathData: pathData,
        };
    }
    var matrix = mat3.create();
    var sx = width / bbox.width;
    var sy = height / bbox.height;
    mat3.translate(matrix, matrix, [-bbox.x, -bbox.y]);
    mat3.scale(matrix, matrix, [sx, sy]);
    mat3.translate(matrix, matrix, [x / sx, y / sy]);
    return {
        pathData: pathData,
        matrix: matrix,
    };
}
function getSymbolType(symbol) {
    if (registeredSymbols[symbol]) {
        return 'registered';
    }
    if (/^(https?|ftp|file)/gi.test(symbol)) {
        return 'url';
    }
    // base64
    if (/^data:/gi.test(symbol)) {
        return 'url';
    }
    if (symbol.indexOf('path://') === 0) {
        return 'path';
    }
    if (/^image:/gi.test(symbol)) {
        return 'image';
    }
}
export function createSymbol(symbolOption, shapeParam, userAttr) {
    var x = shapeParam.x, y = shapeParam.y, width = shapeParam.width, height = shapeParam.height;
    return _createSymbol(symbolOption.symbol, x, y, width, height, userAttr);
}
export function getSymbolAttr(symbolOption, shapeParam) {
    var x = shapeParam.x, y = shapeParam.y, width = shapeParam.width, height = shapeParam.height;
    var symbol = symbolOption.symbol;
    return _getSymbolAttr(symbol, x, y, width, height);
}
function _getSymbolAttr(symbol, x, y, width, height) {
    if (typeof symbol === 'function') {
        return symbol(x, y, width, height).attr;
    }
    if (typeof symbol === 'string') {
        var symbolType = getSymbolType(symbol);
        if (symbolType === 'registered') {
            return registeredSymbols[symbol][1](x, y, width, height);
        }
        if (symbolType === 'url') {
            return getImageAttr(symbol, x, y, width, height);
        }
        if (symbolType === 'path') {
            return getPathAttr(symbol, x, y, width, height);
        }
        if (symbolType === 'image') {
            var url = symbol.slice(8);
            return getImageAttr(url, x, y, width, height);
        }
    }
}
export function _createSymbol(symbol, x, y, width, height, userAttr) {
    if (typeof symbol === 'function') {
        var shape = symbol(x, y, width, height);
        shape.setAttr(userAttr);
        return shape;
    }
    if (typeof symbol === 'string') {
        var symbolType = getSymbolType(symbol);
        var SymbolClass = getSymbolConstructor(symbol, symbolType);
        var attr = void 0;
        if (symbolType === 'registered') {
            attr = registeredSymbols[symbol][1](x, y, width, height);
        }
        else if (symbolType === 'url') {
            attr = getImageAttr(symbol, x, y, width, height);
        }
        else if (symbolType === 'path') {
            attr = getPathAttr(symbol, x, y, width, height);
        }
        else if (symbolType === 'image') {
            var url = symbol.slice(8);
            attr = getImageAttr(url, x, y, width, height);
        }
        return new SymbolClass(__assign(__assign({}, attr), userAttr));
    }
}
export function createSymbolAtCenter(symbol, cx, cy, width, height, userAttr) {
    var x = cx - width / 2;
    var y = cy - height / 2;
    return _createSymbol(symbol, x, y, width, height, userAttr);
}
